"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '@/store';
import { Message } from 'element-ui';
import { sm4 } from "sm-crypto";
import defaultSettings from '@/settings'
const { tokenHeader, tokenHead,SMkey } = defaultSettings





let config = {
  baseURL: process.env.VUE_APP_APIURL,
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

// axios 请求拦截器，
// 在请求头中 添加token 及其他信息
_axios.interceptors.request.use(
  (config) => {
    //获取当前用户的token，添加到头部信息中
    if (store.getters.token) {
      config.headers[tokenHeader || 'Authorization'] = tokenHead + store.getters.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//axios 相应拦截器
// 处理请求响应，对返回的信息状态码，错误信息统一处理
_axios.interceptors.response.use(
  (res) => {
    //此处的相应只是收到了服务器返回的相应信息，即状态码200
    //调用接口操作是否成功需要自行判断
    //response.data 中的内容为服务自定义的返回内容
    if (res && res.data) {
      return res
    } else {
      return Promise.reject(res)
    }
    // return Promise.reject(res)
  },
  (error) => {
    if (error.response) {
      let message = '';
      switch (error.response.status) {
        case 400: message = '请求错误(400)'; break;
        case 401:
          //清空token,重定向到登录页面
          message = '未授权(401)';
          break;
        case 403: message = '拒绝访问(403)'; break;
        case 404: message = '请求错误(404)'; break;
        case 408: message = '请求超时(408)'; break;
        case 500: message = '服务器错误(500)'; break;
        case 501: message = '服务未实现(501)'; break;
        case 502: message = '网络错误(502)'; break;
        case 503: message = '服务不可用(503)'; break;
        case 504: message = '网络超时(503)'; break;
        case 505: message = 'HTTP版本不受支持(503)'; break;
        default: message = `其他错误${error.response.status}`;
      }
      Message.error(message);
    }
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
